import {tabToggle} from "./modules/tab"
import {Accordion} from "./modules/Accodion";
import {Modal} from "./modules/Modal"
import {Step} from "./modules/Step"
import {Indicator} from "./modules/Indicator"
import {Anchor} from "./modules/Anchor"
 
new tabToggle()


document.addEventListener("DOMContentLoaded",()=> {
    new Accordion()
    new Modal()
    new Step()
    new Indicator()
    new Anchor()
})